import React from "react";
import { compose, graphql } from "react-apollo";

import translateErrorMessage from "utils/translateErrorMessage";
import { withSnackbarConsumer, Color } from "contexts/SnackbarContext/SnackbarContext.jsx";
import { PLANT_LOCATIONS_QUERY } from "../generalRegisterQueries";
import { CREATE_PLANT_LOCATION_MUTATION } from "../generalRegisterMutations";
import PlantLocationModal from "./PlantLocationModal";

const PlantLocationCreate = ({
  createPlantLocation,
  snackbarContext,
  toggleModal,
  isOpen,
}) => {
  const onSave = plantLocation => {
    createPlantLocation({
      variables: {
        params: plantLocation
      },
      refetchQueries: [{
        query: PLANT_LOCATIONS_QUERY
      }]
    })
      .then(() => {
        snackbarContext.setNotificationTimeOut(Color.success, "Card criada com sucesso");
        toggleModal();
      })
      .catch(error => {
        snackbarContext.setNotificationTimeOut(Color.danger, translateErrorMessage(error));
      });
  };

  return (
    <PlantLocationModal
      toggleModal={toggleModal}
      isOpen={isOpen}
      title="Cadastrar card"
      onSave={onSave}
    />
  );
};

export default compose(
  graphql(CREATE_PLANT_LOCATION_MUTATION, { name: "createPlantLocation", }),
  withSnackbarConsumer,
)(PlantLocationCreate);
